export class ShipmentsConstant {
  static readonly MAX_PLANNING_TRUCKS = 20;
  static readonly MAX_PLANNING_TRUCKS_MESSAGE = 'TruckLimitExceeded';
  static readonly MAX_PLANNING_TIMEOUT = 30000; // 30s;
  static readonly MAX_PLANNING_TIMEOUT_MESSAGE = 'TimeoutExceeded';
  static readonly NO_PLANNING_TRUCKS_MESSAGE = 'NoPlanningTrucks';
}
